/* =========================================================
   SOULTENTIC: Media modal + collection navigation fixes
   - Adds body.st-modal-open when a modal/dialog is open
   - Hides ONLY true slider clones (does not delete real thumbs)
   - Forces collection product cards to navigate to product page
     even if quick-view tries to hijack the click
   ========================================================= */
(() => {
  const BODY_CLASS = "st-modal-open";

  const isVisible = (el) => {
    if (!el) return false;
    const s = getComputedStyle(el);
    return s.display !== "none" && s.visibility !== "hidden" && el.offsetHeight > 0;
  };

  const getOpenModal = () => {
    const openDialog = document.querySelector("dialog[open]");
    if (openDialog && isVisible(openDialog)) return openDialog;

    const roleDialogs = Array.from(document.querySelectorAll('[role="dialog"]')).filter(isVisible);
    return roleDialogs[0] || null;
  };

  const setModalState = () => {
    document.body.classList.toggle(BODY_CLASS, !!getOpenModal());
  };

  // Hide true clones created by sliders (do NOT remove anything else)
  const hideSliderClones = (root) => {
    if (!root) return;

    const cloneSelectors = [
      ".splide__slide--clone",
      ".swiper-slide-duplicate",
      ".slick-cloned",
      ".glide__slide--clone",
      ".is-clone",
      "[data-clone='true']",
      // Some sliders mark offscreen clones as aria-hidden
      ".splide__slide[aria-hidden='true'].is-clone",
      ".swiper-slide[aria-hidden='true'].swiper-slide-duplicate",
      ".slick-slide[aria-hidden='true'].slick-cloned"
    ].join(",");

    root.querySelectorAll(cloneSelectors).forEach((el) => {
      el.style.display = "none";
    });
  };

  // COLLECTION NAV FIX:
  // If a product card link is clicked, force navigation to its href.
  // This beats themes that intercept clicks to open quick view / image modal.
  const forceCollectionNavigation = (e) => {
    // Only on collection pages
    if (!location.pathname.includes("/collections/")) return;

    const a = e.target.closest && e.target.closest("a[href]");
    if (!a) return;

    // Only act on product links
    // Shopify product URLs contain /products/
    if (!a.getAttribute("href")?.includes("/products/")) return;

    // If user is intentionally clicking a control (quick add buttons etc.), ignore
    const control = e.target.closest && e.target.closest("button, [role='button'], .quick-add, .quick-view");
    if (control) return;

    // Force navigation regardless of theme handlers
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = a.href;
  };

  const runFixes = () => {
    const modal = getOpenModal();
    setModalState();
    if (modal) hideSliderClones(modal);
  };

  // Run initially and on DOM changes
  window.addEventListener("load", runFixes);
  document.addEventListener("DOMContentLoaded", runFixes);

  // Capture click early to beat theme JS
  document.addEventListener("click", forceCollectionNavigation, true);

  const obs = new MutationObserver(() => runFixes());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
